import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { createInvoice, fetchInvoicesByAppointmentId } from "../../store/thunks/invoiceThunk";
import CreateInvoice from "./CreateInvoice";

export default function CreateSingleInvoice({ appointment }) {
  const dispatch = useDispatch();
  const createInvoiceRef = useRef(null);

  // Local state to track the status of the current operation
  const [localStatus, setLocalStatus] = useState("idle");

  const handleSubmit = async () => {
    const invoiceData = createInvoiceRef.current?.getInvoiceData();
    if (!invoiceData) {
      console.error("No invoice data available");
      return;
    }

    setLocalStatus("loading");

    try {
      await dispatch(createInvoice(invoiceData));
      await dispatch(fetchInvoicesByAppointmentId(appointment._id));
      setLocalStatus("succeeded");
    } catch (error) {
      console.error("Error creating invoice:", error);
      setLocalStatus("error");
    }
  };

  return (
    <div>
      <div className="bg-white rounded-sm shadow-md p-6 mb-6">
        <h3 className="text-lg font-semibold mb-4">Create Single Invoice</h3>
        <CreateInvoice ref={createInvoiceRef} appointment={appointment} />
      </div>
      <button
        onClick={handleSubmit}
        disabled={localStatus === "loading" || localStatus === "succeeded"}
        className={`mt-4 px-4 py-2 rounded ${
          localStatus === "loading"
            ? "bg-gray-400"
            : localStatus === "succeeded"
            ? "bg-green-600 hover:bg-green-600"
            : localStatus === "idle"
            ? "bg-indigo-600 hover:bg-indigo-700"
            : "bg-red-600 hover:bg-red-700"
        } text-white`}
      >
        {localStatus === "loading"
          ? "Generating..."
          : localStatus === "succeeded"
          ? "Invoice Created"
          : localStatus === "idle"
          ? "Generate Invoice"
          : "Error"}
      </button>
    </div>
  );
}
